import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

export const MetaData = ({ metadata }) => {
    const timestamp = _.get(metadata, 'Timestamp');
    const dateSavedString = moment(timestamp).format('[Date saved:] MMMM Do YYYY [at] h:mm:ss a [by]');
    const user = _.get(metadata, 'User');
    return <h4>{`${dateSavedString} ${user}`}</h4>;
};



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/MetaData.js